enum RequestState {
    Idle,
    Pending,
    Success,
    Fail,
}

export default RequestState;